import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2, 0),
    paddingTop: theme.spacing(6),
    textAlign: 'center',

    '&.MuiDialog-paperWidthMd': {
      maxWidth: '960px',
    },
  },
  height: {
    padding: theme.spacing(2, 0),
    height: '100%',
    maxHeight: 611,
    borderRadius: 17,
  },
  icon: {
    display: 'block',
    height: 100,
    maxWidth: '100%',
    margin: '0 auto',
  },
  title: {
    color: '#D6246E',
    fontSize: 24,
  },
  content: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  actions: {
    padding: theme.spacing(2, 3),

    '& button': {
      margin: theme.spacing(0, 1),
    },
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
}));
